import React, { useState } from "react";
import { Button as MuiButton, Menu, MenuItem } from "@mui/material";
import { DuelText, RoundAvatar } from "..";
import { Anchor } from "../elements";

export default function ProfileDropdown({ name, username, image, dropdown }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="mc-header-user">
            <MuiButton
                className="mc-dropdown-toggle"
                onClick={handleClick}
                aria-controls={open ? 'profile-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <RoundAvatar src={image} alt="avatar" size="xs" />
                <DuelText title={name} descrip={username} size="xs" />
            </MuiButton>
            <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className="mc-dropdown-paper"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {dropdown?.map((item, index) => (
                    <MenuItem key={index} onClick={handleClose}>
                        <Anchor
                            href={item.path}
                            icon={item.icon}
                            text={item.text}
                            className="mc-dropdown-menu"
                        />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}